import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import { API_URL } from './utils/constants';

/**
 * "Not now" on a ringing 1:1 call: the caller is told this user can't answer
 * now, and the call's pushes stop ringing this user's other browsers.
 */
export const declineCall = async (thread, sessionId) => {
  const threadId = thread.isSubthread
    ? 'subthread'
    : thread.threadId || thread.id;
  const apiPath = `video-chat/${threadId}/decline-call`;

  const body = {
    target: thread.target,
    type: thread.type,
    sessionId,
  };
  const request = {
    url: `${API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    data: body,
  };
  const signedRequest = await createSignedRequest(request);

  await axios(signedRequest);
};
